import { render, staticRenderFns } from "./NoItemsFoundListMessage.vue?vue&type=template&id=5f068212&scoped=true"
import script from "./NoItemsFoundListMessage.vue?vue&type=script&lang=js"
export * from "./NoItemsFoundListMessage.vue?vue&type=script&lang=js"
import style0 from "./NoItemsFoundListMessage.vue?vue&type=style&index=0&id=5f068212&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f068212",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f068212')) {
      api.createRecord('5f068212', component.options)
    } else {
      api.reload('5f068212', component.options)
    }
    module.hot.accept("./NoItemsFoundListMessage.vue?vue&type=template&id=5f068212&scoped=true", function () {
      api.rerender('5f068212', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/NoItemsFoundListMessage.vue"
export default component.exports